/**
 * Heading and status line of the cart's "ready for payment" view.
 *
 * The old line always said "N orders waiting for payment", even after every order was paid
 * (found 2026-10-31: the item row read "Paid" while the header still said "1 order waiting").
 */
export interface CartHeaderText {
  title: string;
  status: string;
}

const orders = (n: number) => `${n} order${n === 1 ? '' : 's'}`;

export function cartReadyHeader(total: number, paid: number): CartHeaderText {
  const paidCount = Math.min(Math.max(paid, 0), total);
  if (total > 0 && paidCount === total) {
    return { title: 'Payment complete', status: total === 1 ? 'Your order is paid.' : `All ${total} orders are paid.` };
  }
  if (paidCount > 0) {
    return {
      title: 'Ready for payment',
      status: `${paidCount} of ${orders(total)} paid, ${total - paidCount} waiting for payment.`,
    };
  }
  return { title: 'Ready for payment', status: `${orders(total)} waiting for payment.` };
}
